import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { isUrl } from '@ant-design/pro-utils';
/**
 * simple模式渲染logo的方式
 *
 * @param logo
 * @param title
 * @returns
 */

export var renderLogo = function renderLogo(logo, title) {
  if (logo && typeof logo === 'string' && isUrl(logo)) {
    return _jsx("img", {
      src: logo,
      alt: "logo"
    });
  }

  if (typeof logo === 'function') {
    return logo();
  }

  if (logo && typeof logo === 'string') {
    return _jsx("div", {
      id: "avatarLogo",
      children: logo
    });
  }

  if (!logo && title && typeof title === 'string') {
    var symbol = title.substring(0, 1);
    return _jsx("div", {
      id: "avatarLogo",
      children: symbol
    });
  }

  return logo;
};
export var SimpleContent = function SimpleContent(props) {
  var appList = props.appList,
      baseClassName = props.baseClassName,
      hashId = props.hashId;
  return _jsx("div", {
    className: "".concat(baseClassName, "-content ").concat(hashId),
    children: _jsx("ul", {
      className: "".concat(baseClassName, "-content-list ").concat(hashId),
      children: appList === null || appList === void 0 ? void 0 : appList.map(function (app, index) {
        return _jsx("li", {
          className: "".concat(baseClassName, "-content-list-item ").concat(hashId),
          children: _jsxs("a", {
            href: app.url,
            target: app.target,
            rel: "noreferrer",
            children: [renderLogo(app.icon, app.title), _jsx("div", {
              children: _jsx("div", {
                children: app.title
              })
            })]
          })
        }, index);
      })
    })
  });
};